import React, { useState } from 'react'
import moment from 'moment'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import SmsPhone from '~/pages/cp/includes/sms/phone'
import Topup from '~/pages/cp/company/sms/topup'
import helpers from '~/Classes/helpers'
import i18n from '~/i18n'
import { useDispatch, useSelector } from 'react-redux'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here

export default function SmsSendPreview({ campaign, content }) {
    const accountMaster = useSelector((state) => state.accountMaster)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [phoneValid, setPhoneValid] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)
    const [message, setMessage] = useState('')
    const [approveDrawer, setApproveDrawer] = useState(null)

    const dispatch = useDispatch()

    const accountIsApproved = accountMaster.accountMaster.approved
    const hasCredits = accountMaster.accountMaster.smsCredits > 0

    const sendPreview = async () => {
        setSending(true)
        setError(null)
        try {
            await axios.post('/transaction/sms', {
                toAddress: phoneNumber,
                subject: campaign.subject,
                content
            })
            setMessage('SMS Sent')
            setTimeout(() => setMessage(''), 5000)
        } catch (e) {
            setError(e.data.error)
        }
        setSending(false)
    }

    const updatePhoneNumber = (e) => {
        setPhoneNumber(e.currentTarget.value)
        setPhoneValid(e.valid)
    }

    const activateAccount = () => {
        var theDrawer = (
            <NewUserForm
                from='campaign'
                finish={() => {
                    setApproveDrawer(null)
                }}
            />
        )
        setApproveDrawer(theDrawer)
    }

    const topup = () => {
        const theDrawer = (
            <Topup
                onClose={() => {
                    dispatch(siteMaster.alterSiteDrawer(false))
                }}
            />
        )
        dispatch(siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, false, '500px'))
    }

    const timestamp = (moment(campaign.startDate) < moment() ? moment() : moment(campaign.startDate)).format(
        'DD MMM, HH:mm'
    )
    const result = helpers.getSmsCredits(campaign, content)

    return (
        <Paper className='mar-b20'>
            <Row>
                {/* <Column xs={6} className="center-xs">
                    <div style={{ height: 300, overflow: 'hidden', justifyContent: 'center', textAlign: '-webkit-center', backgroundColor: '#F8F9FB', borderRadius: 8, padding: 40 }}>
                        <SmsPhone from={campaign.subject} content={result.html} timestamp={timestamp} />
                    </div>
                </Column> */}
                {/* <span>({(accountMaster.accountMaster.smsCredits || 0)} credits available)</span> */}
                <Column>
                    <h4 className='mar-b20'>{i18n.t('campaigns:standard.step3.testSms')}</h4>
                    <div className='mar-b16'>
                        <TextInput
                            type='telno'
                            label={
                                <span style={{ fontWeight: 600 }}>
                                    Phone Number{' '}
                                    <div style={{ fontWeight: 300, fontSize: 12 }}>
                                        This will use {result.messages} {result.messages > 1 ? 'credits' : 'credit'}
                                    </div>{' '}
                                </span>
                            }
                            onChange={updatePhoneNumber}
                            value={phoneNumber}
                            defaultCountry='gb'
                            onlyCountries={['gb']}
                            allowDropdown={false}
                            error={error}
                        />
                    </div>
                    {accountIsApproved ? (
                        <Button
                            id='send-sms'
                            className='button-sml outline'
                            text={'Send Test SMS'}
                            iconRight={<Icons icon='arrowRight' />}
                            onClick={sendPreview}
                        />
                    ) : (
                        <Button
                            id='send-sms'
                            disabled={true}
                            tooltip={'Approval is required before SMS previews can be sent'}
                            for={'send-sms'}
                            className='button-sml outline'
                            text={'Send Test SMS'}
                            iconRight={<Icons icon='arrowRight' />}
                            onClick={sendPreview}
                        />
                    )}
                    {message && <div className='text-primary text-sml mar-t10'>{message}</div>}
                </Column>
            </Row>
            {approveDrawer}
        </Paper>
    )
}
